import { createContext } from 'react';
import StylesProps from '../interfaces/StylesProps';

interface StylesContextProps {
  styles: StylesProps;
  setStyles: React.Dispatch<React.SetStateAction<StylesProps>>;
}

const contextDefault: StylesContextProps = {
  styles: {
    menuId: 0,
    urlId: '',
    bgColor: '',
    bgLogoColor: '',
    btnBgColor: '',
    btnCircleColor: '',
    btnColor: '',
    logoImg: '',
    textColor: '',
    topTextColor: '',
    footerColor: '',
    bgCategoryContainer: '',
    menuIconColor: '',
    secondaryTextColor: '',
    btnPrevNext: '', 
    btnAddChart: '',
  },
  setStyles: () => {}
}

const StylesContext = createContext<StylesContextProps>(contextDefault);

export default StylesContext;